import {
    Box, Card, Grid, IconButton, TextField, Typography,
    InputAdornment
  } from '@mui/material';
  import MDButton from 'components/MDButton';
  import { AgGridTable } from 'components/tables/AgGridTable';
  import React, { useEffect, useRef, useState } from 'react';
  import { useDispatch, useSelector } from 'react-redux';
  import { useLocation, useNavigate, useParams } from 'react-router-dom';
  import { openSnackbar } from '../../../../redux/slices/common';
  import { CloseRounded } from '@mui/icons-material';
  import AddRoundedIcon from '@mui/icons-material/AddRounded';
  import EditIcon from 'common/customIcons/edit';
  import DeleteIcon from 'common/customIcons/delete';
  import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../../../redux/slices/modalSlice';
  import { useDebounce } from 'hooks/useDebounce';
  import SearchIcon from 'common/customIcons/search';
import { deleteProductTrait, fetchProductTraits } from '../../../../redux/slices/hyperwolf/products';
import SelectProductTrait from './SelectProductTrait';
    
  export default function ProductTraits({ totalProduct = 0 }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { productId } = useParams()
    const { pathname } = useLocation();
    const mainGridApiRef = useRef('');
    const searchTermRef = useRef('')
    const pageRef = useRef(0);
    const gridRefApi = useRef();
    const { loadingProductTraits } = useSelector(state => state.hyperwolfProducts|| {});
    const { data = [] } = useSelector(state => state.hyperwolfProducts.productTraits || {});
    const { productTraits =[] } = data
    const [editTrait, setEditTrait] = useState(false)
    const [openSelectModal, setOpenSelectModal] = useState(false)
    const [traitId, setTraitId] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
  
    const columnDefs = [
      {
        headerName: 'Major Traits',
        field: 'mainTraitName',
        key: 'mainTraitName',
        suppressMenu: false,
        cellRenderer: (props) => {
          if (!props?.value) { return '-' }
          else { return props?.value }
        }
      },
      {
        headerName: 'Sub Traits',
        field: 'subTraitName',
        key: 'subTraitName',
        suppressMenu: false
      },
      {
        headerName: 'Value',
        field: 'valueAndUnit',
        key: 'valueAndUnit',
        suppressMenu: false
      },
      {
        headerName: 'Actions',
        suppressMenu: true,
        minWidth: 80,
        cellRenderer: (props) => {
          return <Box className='action-edit w-100 jc-end' display='flex'>
            <IconButton onClick={(e) => {
              e.stopPropagation();
              onEditClicked(props);
            }} color='primary' size='small' variant='primary'>
              <EditIcon width='16px' height='16px' />
            </IconButton>
            <IconButton onClick={(e) => {
              e.stopPropagation();
              dispatch(openCustomModalDialog(
                {
                  modalData: {
                    deleteHandler,
                    deleteId: props.data?.id,
                    deleteType: 'product trait'
                  }, modal: 'DELETE_MODAL'
                }));
            }} color='error' size='small' variant='primary' sx={{ marginLeft: 1 }}>
              <DeleteIcon width='16px' height='16px' />
            </IconButton>
          </Box>;
        }
      }
  
    ];
  
    const getRows = async (params) => {
      gridRefApi.current = params;
      dispatch(fetchProductTraits({ id: productId, filters: { skip: pageRef.current, limit: 20, searchTerm: searchTermRef.current } })).unwrap().then(res => {
        const { productTraits = [], total } = res.data || {}
        params.successCallback(productTraits, total);
        pageRef.current = pageRef.current + 20;
      })
    }
  
    const handleSearch = useDebounce(() => {
      pageRef.current = 0;
      searchFn();
    }, 500);
  
    const searchHandler = (searchValue) => {
      setSearchTerm(searchValue);
      searchTermRef.current = searchValue;
      handleSearch(searchValue);
    };
  
    const deleteHandler = (productTraitId) => {
      dispatch(setModalLoader(true));
      dispatch(deleteProductTrait({ productId, productTraitId })).unwrap().then((res) => {
        showError(res?.data?.message, 'success');
        dispatch(closeCustomModalDialog());
        pageRef.current = 0;
        searchFn();
        getRows(gridRefApi.current);
      }).catch((err) => {
        dispatch(setModalLoader(false));
        showError(err?.message, 'error');
      });
    };
  
    const onEditClicked = (props) => {
      setTraitId(props?.data?.id)
      setOpenSelectModal(true)
    }
  
    const searchFn = () => {
      const dataSource = {
        getRows
      };
      mainGridApiRef.current.ensureIndexVisible(0, null);
      mainGridApiRef.current.setGridOption('datasource', dataSource);
    };
  
  
    const onRowClicked = (row) => {  
      if (row?.colDef?.headerName === 'On Hold') {
        // dispatch(fetchHoldQuantity(productId))
      }
      else {
        // navigate(`/inventories/${row.data?.inventoryId}`);
      }
    };
  
  
    const showError = (message, errortype) => {
      if (errortype === 'success') {
        dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
      }
      if (errortype === 'error') {
        dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
      }
    };
  
    useEffect(() => {
      if (productId) {
        dispatch(fetchProductTraits({ id: productId, filters: { skip: pageRef.current, limit: 20, } })).unwrap()
      }
    }, [productId]);
  
    useEffect(() => {
      if (mainGridApiRef?.current) {
        if (loadingProductTraits) {
          mainGridApiRef.current.showLoadingOverlay();
        } else if (productTraits?.length === 0) {
          mainGridApiRef.current.showNoRowsOverlay();
        }
        else {
          mainGridApiRef.current.hideOverlay();
        }
      }
    }, [productTraits, loadingProductTraits]);
  
    const handleSelectTrait = () => {
      setTraitId('')
      setOpenSelectModal(true)
    }
  
    return (
      <Card sx={{ p: 3, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
  
  
        <Grid container xs={12} md={12} className="mb-3 section-custom-search-field ">
  
          <Grid item xs={12} sm={4} md={4} lg={3} xxl={3} className='pt-0 d-flex align-center'>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A", fontSize: "1.125rem" }}>{!openSelectModal ? 'Product Traits' : openSelectModal && traitId ? 'Edit Product Traits' : openSelectModal && !traitId ? 'Add Product Traits' : ''}</Typography>
          </Grid>
  
          {!openSelectModal &&
            <Grid item xs={12} sm={8} md={8} lg={9} xxl={9} className="custom-search-select flex-end  align-center  d-flex gap-2">
              <TextField
                className="custom-search-field"
                placeholder="Search"
                label=""
                value={searchTerm}
                onChange={(e) => searchHandler(e.target.value)}
                // sx={{ minWidth: "280px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton size="small">
                        <SearchIcon width="18px" height="18px" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment:
                    searchTerm?.length > 0 ? (
                      <InputAdornment>
                        <IconButton onClick={() => searchHandler("")} size="small">
                          <CloseRounded />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                }}
              />
  
  
              <MDButton
                startIcon={<AddRoundedIcon fontSize="large" />}
                variant="contained"
                color="primary"
                onClick={handleSelectTrait}
              >
                Select Product Traits
              </MDButton>
  
  
            </Grid>
          }
        </Grid>
  
        {openSelectModal ? (
          <SelectProductTrait handleCancel={() => setOpenSelectModal(false)} searchFn={searchFn} closeForm={() => setOpenSelectModal(false)} productTraits={productTraits} productTraitId={traitId} />
        ) :
               (
            <>
              <AgGridTable
                col={columnDefs}
                getRows={getRows}
                pageRef={pageRef}
                onRowClicked={onRowClicked}
                isLoading={loadingProductTraits}
                mainGridApiRef={mainGridApiRef}
                style={{ height: '30vh' }}
              />
            </>
          )}
      </Card>
  
    );
  }